'use strict';

// Browser documents owned by the maintained public Pug renderer. Workspace,
// catalog and native screens keep their existing execution and routing owners.
const authPaths = ['/login', '/signup', '/forgot-password', '/reset-password', '/login-authorize'];
// Existing session/system controllers run before the public marketing router.
const systemPaths = ['/error', '/unsubscribed', '/login/chad'];
const staticPaths = [
  '/', '/pricing', '/about', '/api', '/voice', '/free-ai-chat', '/alternatives',
  '/download', '/mac', '/extension', '/switch', '/christian-ai', '/right-wing-ai',
  '/brand', '/changelog', '/based-benchmark', '/llms', '/contact', '/feedback',
  '/sites/report', '/privacy-policy', '/terms-of-service', '/terms-of-sale',
  '/refund-policy', '/dmca', '/ccpa', '/affiliate-program-agreement',
  ...authPaths,
];
const families = ['/features', '/docs', '/learn', '/blog', '/use-cases'];
const exact = new Set([...staticPaths, ...systemPaths]);
function ownsPublicPage(pathname) {
  if (typeof pathname !== 'string' || !pathname.startsWith('/') || pathname.startsWith('//')) return false;
  const path = pathname.split(/[?#]/, 1)[0].replace(/\/+$/, '') || '/';
  // The localized server boundary also owns missing descendants, so an
  // untranslated URL cannot fall through to a retained Expo public screen.
  if (require('./locales.cjs').matchLocalizedPath(path)) return true;
  if (exact.has(path)) return true;
  if (path.endsWith('-alternative') && path.split('/').length === 2) return true;
  // Asset/feed URLs never become browser document handoffs.
  if (path.split('/').at(-1).includes('.') || path.startsWith('/docs/screenshots/')) return false;
  if (families.some(root => path === root || path.startsWith(root + '/'))) return true;
  if (path.startsWith('/unsubscribe/') && [4, 5].includes(path.split('/').length)) return true;
  return path.startsWith('/start/') && path.split('/').length === 3;
}
function publicPageAlias(pathname) {
  const path = String(pathname || '').replace(/\/+$/, '').toLowerCase();
  const aliases = { '/guidelines': '/terms-of-service', '/terms': '/terms-of-service', '/privacy': '/privacy-policy', '/enterprise': '/pricing' };
  if (Object.hasOwn(aliases, path)) return aliases[path];
  if (path.endsWith('/index.html')) {
    const parent = path.slice(0, -'/index.html'.length) || '/';
    if (ownsPublicPage(parent)) return parent;
  }
  if (path.endsWith('.html') && ownsPublicPage(path.slice(0, -5))) return path.slice(0, -5) || '/';
  return null;
}
module.exports = { authPaths, systemPaths, staticPaths, families, ownsPublicPage, publicPageAlias };
